module.exports = __webpack_public_path__ + "images/emoji/heavy_exclamation_mark.81e5b2887c7540f2ac65.png";